module.exports = __webpack_public_path__ + "media/images/Group-e2d743106a815e924c27d0f358b8c1bd.jpg";